import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "loader-container"
}
const _hoisted_2 = { class: "group-title" }

import { computed, onMounted } from 'vue'
import { WarningFilled } from '@element-plus/icons'

import { Setting, SettingKey, SettingGroup } from '@/models/setting'

import { commonCase } from '@/helpers/strings'
import { getSettingPostfixByKey } from '@/helpers/app-settings'
import { RbacAction, RbacEntity } from '@/helpers/rbac'

import { useSettingsStore } from '@/store/settings'

import CommonError from '@/components/CommonError.vue'
import EditableInputNumber from '@/components/EditableInputNumber.vue'
import useScopeCheck from '@/composables/useScopeCheck'


export default /*@__PURE__*/_defineComponent({
  __name: 'Settings',
  setup(__props) {

const settingsStore = useSettingsStore()
const settingsModule = settingsStore.settingsModule

const isInitialLoadingDone = computed(() => settingsModule.isInitialLoadingDone)
const error = computed(() => settingsModule.error)
const settingsByGroup = computed(() => settingsStore.settingsByGroup)

const loadingKeys = computed(() => settingsModule.updating.loadingKeys)
const successKeys = computed(() => settingsModule.updating.successKeys)

const allowedEditing = useScopeCheck(RbacAction.UPDATE, RbacEntity.APP_SETTINGS)

const getSettings = () => {
  settingsStore.getAppSettings()
}

onMounted(() => {
  if (!isInitialLoadingDone.value) getSettings()
})

const handleSavePress = (
  id: number,
  key: SettingKey,
  value: number | string
) => {
  settingsStore.updateAppSetting(id, key, String(value))
}

const getSortedSettings = (settings: Setting[]) => {
  return [...settings].sort((a, b) => {
    if (a.key === SettingKey.IS_INSURANCE_ENABLED) return -1
    if (b.key === SettingKey.IS_INSURANCE_ENABLED) return 1
    return 0
  })
}

const sortedGroups = computed(() => {
  const { value } = settingsByGroup
  if (!value) return {}
  const entries = Object.entries(value)

  const sorted = entries.sort(([a], [b]) => {
    if (a === 'ev_trip') return 1
    if (b === 'ev_trip') return -1
    return a.localeCompare(b)
  })

  return Object.fromEntries(sorted)
})

const downloadCSVList = () => {
  settingsStore.getBrandListModelCSV(SettingKey.INSURANCE_MODEL_LIST_CSV)
}

const downloadXLSXList = () => {
  settingsStore.getBrandListModelXLSX(SettingKey.INSURANCE_MODEL_LIST_XLSX)
}

const apiInsuranceButtons = computed(() => [
  {
    title: 'Get Vehicle (Model / Brand) List 2 (CSV)',
    buttonProps: {
      click: downloadCSVList,
      title: 'Download',
      key: SettingKey.INSURANCE_MODEL_LIST_CSV,
    },
  },
  {
    title: 'Get Vehicle (Model / Brand) List 2 (XLSX)',
    buttonProps: {
      click: downloadXLSXList,
      title: 'Download',
      key: SettingKey.INSURANCE_MODEL_LIST_XLSX,
    },
  },
])

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _directive_loading = _resolveDirective("loading")!

  return (error.value)
    ? (_openBlock(), _createBlock(CommonError, {
        key: 0,
        errorMessage: error.value,
        onRetryPress: getSettings
      }, null, 8, ["errorMessage"]))
    : (!isInitialLoadingDone.value)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, null, 512)), [
          [_directive_loading, true]
        ])
      : (_openBlock(), _createBlock(_component_el_scrollbar, {
          key: 2,
          always: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 24 }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedGroups.value, (settings, key) => {
                  return (_openBlock(), _createBlock(_component_el_col, {
                    key: key,
                    span: 12
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("h3", _hoisted_2, _toDisplayString(_unref(commonCase)(String(key), true)), 1),
                      _createVNode(_component_el_table, {
                        data: getSortedSettings(settings),
                        "show-header": false,
                        border: "",
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_table_column, {
                            width: "210px",
                            prop: "key"
                          }, {
                            default: _withCtx(({ row: { key, group } }) => [
                              _createTextVNode(_toDisplayString(_unref(commonCase)(key, true)) + " ", 1),
                              _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
                              _createTextVNode(" " + _toDisplayString(_unref(getSettingPostfixByKey)(key)) + " ", 1),
                              (_unref(SettingGroup).COVERAGE_PACKAGE === group)
                                ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                    key: 0,
                                    placement: "top-start"
                                  }, {
                                    content: _withCtx(() => _cache[0] || (_cache[0] = [
                                      _createTextVNode(" Attention! "),
                                      _createElementVNode("br", null, null, -1),
                                      _createTextVNode(" Before editing the values in the table check if the insurance company allows work with them. "),
                                      _createElementVNode("br", null, null, -1),
                                      _createTextVNode(" If the values in the table are different from those provided/supported by the insurance company, the system won't work correctly! ")
                                    ])),
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_icon, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(WarningFilled), { color: "#ebb563" })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_table_column, { prop: "value" }, {
                            default: _withCtx(({ row: { value, id, key } }) => [
                              (key === _unref(SettingKey).IS_INSURANCE_ENABLED)
                                ? (_openBlock(), _createBlock(_component_el_switch, {
                                    key: 0,
                                    disabled: !_unref(allowedEditing),
                                    loading: loadingKeys.value.includes(key),
                                    "model-value": value === 'true',
                                    "active-text": "Enabled",
                                    "inactive-text": "Disabled",
                                    onChange: ($event: any) => (handleSavePress(id, key, $event ? 'true' : 'false'))
                                  }, null, 8, ["disabled", "loading", "model-value", "onChange"]))
                                : (_openBlock(), _createBlock(EditableInputNumber, {
                                    key: 1,
                                    editable: _unref(allowedEditing),
                                    min: key,
                                    "is-pricing-input": key !== 'car_search_radius',
                                    settingKey: key,
                                    sourceValue: Number(value),
                                    loading: loadingKeys.value.includes(key),
                                    success: successKeys.value.includes(key),
                                    onSave: ($event: any) => (handleSavePress(id, key, $event))
                                  }, null, 8, ["editable", "min", "is-pricing-input", "settingKey", "sourceValue", "loading", "success", "onSave"]))
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["data"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128)),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "group-title" }, "Insurance API Assistance Buttons", -1)),
                    _createVNode(_component_el_table, {
                      data: apiInsuranceButtons.value,
                      "show-header": false,
                      border: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, { key: "title" }, {
                          default: _withCtx(({ row: { title } }) => [
                            _createTextVNode(_toDisplayString(title), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          align: "right",
                          key: "buttonProps"
                        }, {
                          default: _withCtx(({ row: { buttonProps } }) => [
                            _createVNode(_component_el_button, {
                              type: "primary",
                              onClick: buttonProps.click,
                              loading: loadingKeys.value.includes(buttonProps.key)
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(buttonProps.title), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick", "loading"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["data"])
                  ]),
                  _: 1,
                  __: [2]
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
}
}

})